import "./DatePickerInput.css";
import React from "react";

const DatePickerInput = ({ onHandleChange }) => {
  return (
    <div className="date-container flex-grow-1">
      <input
        className="date-input"
        type="date"
        name=""
        id=""
        onChange={onHandleChange}
      />
    </div>
  );
};

export default DatePickerInput;
